import { observable, makeAutoObservable } from "mobx";
class ReportStore {
  constructor() {
    makeAutoObservable(this);
  }
  showReportDialog = false;
  reportName = "";
  headerText = "SPARS Report";
  reportParameters = {};
  isBusy = true;
}

const reportStore = new ReportStore();

export default reportStore;

